
<template>
  <div class="body">
    <!-- 待认领包裹 -->
    <baseBreadcrumb :page="$t('message.claimAParcel')" :menu="$t('message.claimAParcel')" />
    <div class="body">
      <div class="search">
        <!-- 开始日期 -->
        <div class="item">
          <el-date-picker v-model="data.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="data.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="['23:59:59']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 物流号 -->
        <!-- <div class="item">
          <el-input :placeholder="$t('message.logisticsNumber')" v-model="data.express_no">
          </el-input>
                            </div> -->
        <!-- 按钮 -->
        <div class="item">
          <el-button type="primary" @click="search">{{
            $t("message.search")
          }}</el-button>
          <!-- <el-button @click="reset">{{ $t("message.reset") }}</el-button> -->
        </div>
        <!-- 新增 -->
        <el-button class="add" type="success" @click="add" v-if="isAuth(309)">{{
          $t("message.add")
        }}</el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" v-if="show">
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>

          <!--  登记时间-->
          <el-table-column align="center" :label="$t('message.registrationTime')" prop="created_at" width="150px">
          </el-table-column>

          <!--  登记人-->
          <el-table-column align="center" :label="$t('message.personOfRegistration')" prop="rowNumber" width="110px">
            <template slot-scope="scope" v-if="scope.row.create_admin">
              <p>{{ scope.row.create_admin.id }}</p>
              <p>{{ scope.row.create_admin.realname }}</p>
            </template>
          </el-table-column>
          <!--  物流号-->
          <el-table-column align="center" :label="$t('message.logisticsNumber')" prop="express_no">
          </el-table-column>
          <!--  包裹图片-->
          <el-table-column align="center" :label="$t('message.pictureOfPackage')" prop="rowNumber" width="150px">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="scope.row.package_image" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="scope.row.package_image" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <!--  商品图片-->
          <el-table-column align="center" :label="$t('message.productPicture')" prop="rowNumber" width="150px">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="scope.row.goods_image" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="scope.row.goods_image" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <!--  商品备注-->
          <el-table-column align="center" :label="$t('message.commodityNote')" prop="remark">
          </el-table-column>

          <!--  操作-->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="110px">
            <template slot-scope="scope">
              <!-- 认领 -->
              <p>
                <el-button size="small" type="success" @click="showClaim(scope.row.id)" v-if="isAuth(312)">{{
                  $t("message.toClaim")
                }}</el-button>
              </p>
              <!-- 修改 -->
              <p>
                <el-button size="small" type="success" class="primary" @click="edit(scope.row)" v-if="isAuth(310)">{{
                  $t("message.edit")
                }}</el-button>
              </p>
              <!-- 删除 -->
              <p>
                <el-button size="small" type="success" class="dark" @click="claimDelete(scope.row.id)"
                  v-if="isAuth(311)">{{
                    $t("message.delete") }}</el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="data.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="data.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 新增/修改 -->
      <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="addDialogVisible" width="488px" center>
        <div class="content">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <!-- 物流号 -->
            <el-form-item :label="$t('message.logisticsNumber') + ':'" prop="express_no">
              <el-input v-model="ruleForm.express_no"></el-input>
            </el-form-item>
            <!-- 包裹图片 -->
            <el-form-item :label="$t('message.pictureOfPackage') + ':'" prop="package_image">
              <div class="upload">
                <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                  :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <el-image style="width: 100px; height: 100px" :src="ruleForm.package_image"
                v-if="ruleForm.package_image"></el-image>
            </el-form-item>
            <!--商品图片  -->
            <el-form-item :label="$t('message.productPicture') + ':'" prop="goods_image">
              <div class="upload">
                <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                  :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <el-image style="width: 100px; height: 100px" :src="ruleForm.goods_image"
                v-if="ruleForm.goods_image"></el-image>
            </el-form-item>
            <!-- 商品备注 -->
            <el-form-item :label="$t('message.commodityNote') + ':'" prop="remark">
              <el-input v-model="ruleForm.remark" type="textarea"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <!--取 消  -->
          <el-button @click="addDialogVisible = false">{{
            $t("message.cancel")
          }}</el-button>
          <!-- 保存 -->
          <el-button type="primary" @click="claimStore" v-if="isAdd">{{
            $t("message.ok")
          }}</el-button>
          <el-button type="primary" @click="claimUpdate" v-else>{{
            $t("message.ok")
          }}</el-button>
        </span>
      </el-dialog>
      <!-- 认领 -->
      <el-dialog :title="$t('message.relatedTransactionNumber')" :close-on-click-modal="false"
        :visible.sync="claimDialogVisible" width="488px" center>
        <div class="content">
          <!-- 关联交易号 -->
          <div class="label">
            {{ $t("message.relatedTransactionNumber") }}
            ：
          </div>
          <div class="val">
            <el-input v-model="claimDada.purchase_no"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!--取 消  -->
          <el-button @click="claimDialogVisible = false">{{
            $t("message.cancel")
          }}</el-button>
          <!-- 保存 -->
          <el-button type="primary" @click="claimRelationPurchaseNo">{{
            $t("message.ok")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addDialogVisible: false,
      isAdd: true,
      title: "",
      tableData: [{}],
      show: true,
      data: {
        page: 1,
        pageSize: 10,
        status: 1,
        express_no: "",
      },
      total: 0,
      ruleForm: {},
      rules: {
        express_no: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        package_image: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        goods_image: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
      claimDialogVisible: false,
      claimDada: {},
    };
  },
  components: {},
  created() {
    this.claimList();
  },
  methods: {
    claimList() {
      this.$api.signInApi.claimList(this.data).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        console.log(res);
      });
    },
    // 追加
    add() {
      this.ruleForm = {
        express_no: "",
        package_image: "",
        goods_image: "",
        remark: "",
      };
      this.title = this.$t("message.packageAddition");
      this.isAdd = true;
      this.addDialogVisible = true;
    },
    // 修改
    edit(item) {
      this.ruleForm = {
        id: item.id,
        express_no: item.express_no,
        package_image: item.package_image,
        goods_image: item.goods_image,
        remark: item.remark,
      };

      this.title = this.$t("message.packageEdit");
      this.isAdd = false;
      this.addDialogVisible = true;
    },
    // 认领
    showClaim(id) {
      this.claimDada = {
        id,
        purchase_no: "",
      };
      this.claimDialogVisible = true;
    },
    // 搜索
    search() {
      this.data.page = 1;
      this.claimList();
    },
    // 重置
    reset() {
      this.data = {
        page: 1,
        pageSize: 10,
        status: 1,
        express_no: "",
      };
      this.claimList();
    },
    // 分页
    handleCurrentChange(val) {
      this.data.page = val;
      this.claimList();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.claimList();
    },
    // 新增
    claimStore() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.signInApi.claimStore(this.ruleForm).then((res) => {
            this.$message.success(res.message);
            this.addDialogVisible = false;
            this.claimList();
          });
        }
      });
    },
    // 修改
    claimUpdate() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.signInApi.claimUpdate(this.ruleForm).then((res) => {
            this.$message.success(res.message);
            this.addDialogVisible = false;
            this.claimList();
          });
        }
      });
    },
    // 删除
    claimDelete(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.signInApi.claimDelete({ id }).then((res) => {
            this.$message.success(res.msg);
            this.claimList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    //认领
    claimRelationPurchaseNo() {
      if (this.claimDada.purchase_no == "")
        return this.$message.error(
          this.$t("message.pleaseEnterTransactionNumber")
        );
      this.$api.signInApi
        .claimRelationPurchaseNo(this.claimDada)
        .then((res) => {
          this.$message.success(res.msg);
          this.claimDialogVisible = false;
          this.claimList();
        });
    },
    // 上传包裹图片
    handleAvatarSuccess(res) {
      this.ruleForm.goods_image = res.data;
      this.$message.success(res.msg);
      this.$forceUpdate();
    },
    // 上传包裹图片
    handleAvatarSuccess1(res) {
      this.ruleForm.package_image = res.data;
      this.$message.success(res.msg);
      this.$forceUpdate();
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin-bottom: 24px;
  display: flex;
  position: relative;

  .item {
    width: 220px;
    margin-right: 24px;

    /deep/.el-date-editor {
      width: 220px;
    }
  }

  .add {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.table {
  p {
    margin-bottom: 5px;

    .el-button {
      width: 80px;
    }
  }
}

.content {
  padding: 0 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}

.upload {
  display: inline-block;
  margin-right: 20px;
}

img {
  width: 100px;
  height: 100px;
  border-radius: 6px;
  border: 1px dashed #d9d9d9 !important;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>